import selectPositionModalTemplate from '../../../pages/billing/invoices/views/modals/select-positions-modal.tpl.html';
import PosVouchersModalController from './vouchers-modal-controller';
import posVouchersModalTemplate from '../views/pos-vouchers-modal.tpl.html';

export default class PosDefaultController {

    constructor($uibModal, SweetAlert, SelectBox, $http, $q, $filter, $scope, $rootScope, $state, Contacts, Users, InvoiceTemplates, PaymentsService, locale, Invoice) {
        this.modal = $uibModal;
        this.sweetAlert = SweetAlert;
        this.selectBox = SelectBox;
        this.api = $http;
        this.queue = $q;
        this.filter = $filter;
        this.scope = $scope;
        this.rootScope = $rootScope;
        this.state = $state;
        this.invoiceModel = Invoice;
        this.contactsStore = Contacts.reset({
            listview: 'PosModalContactSelector',
            persist: false
        });
        this.usersStore = Users;
        this.invoiceTemplatesStore = InvoiceTemplates.reset({
            listview: 'PosModalInvoiceTemplates',
            persist: false
        });
        this.paymentsService = PaymentsService;
        locale.ready(['billing']);

        this.loading = true;
        this.submitting = false;
        this.deposits = {
            invoice_templates: [],
            payment_types: []
        };
        this.overallSum = 0;
        this.currentContact = null;

        this.currentSelectedAddressType = 'preferred';
        this.addressEditable = false;
        this.sendInvoiceToEmailAddress = '';

        this.initWatchers();
        this.initSettings();

        this.updateDeposits();
    }

    // Internal
    initSettings() {
        this.data = {
            contact_id: -1,
            invoice_template_id: -1,
            invoice_date: new Date(),
            positions: [],
            processing_fee: 0,
            address: '',
            payment_type: 'cash'
        };

        this.data.contact_id = this.usersStore.state.company.csettings.billing.pos_default_contact;
        if (this.data.contact_id > -1) {
            this.updateContactData();
        }

        this.data.invoice_template_id = this.usersStore.state.company.csettings.billing.pos_default_invoice_template;

        if (this.usersStore.state.company.csettings.billing.pos_default_positions.length > 0) {
            const positionsQueue = [];
            _.each(this.usersStore.state.company.csettings.billing.pos_default_positions, (posId) => {
                positionsQueue.push(this.api.get(`billing/positions/${posId}`));
            });

            this.queue.all(positionsQueue).then((positionResults) => {
                _.each(positionResults, (result) => {
                    const curPos = result.data.data;

                    this.data.positions.push({
                        order: this.data.positions.length + 1,
                        position_id: curPos.id,
                        label: curPos.label,
                        originalLabel: _.cloneDeep(curPos.label),
                        description: curPos.description,
                        price_per_unit: curPos.price_per_unit,
                        unit: curPos.unit,
                        amount: 0
                    });
                });
            });
        }
    }

    initWatchers() {
        this.scope.$watch(() => {
            return this.currentSelectedAddressType;
        }, (value) => {
            this.updateAddress();
        });
        this.scope.$watch(() => {
            return this.data.positions;
        }, (value) => {
            this.calculateOverallSum();
        }, true);
        this.scope.$watch(() => {
            return this.data.processing_fee;
        }, (value) => {
            this.calculateOverallSum();
        }, true);
    }

    calculateOverallSum() {
        let overallSum = this.data.processing_fee;
        _.each(this.data.positions, (v) => {
            overallSum += v.amount * v.price_per_unit;
        });

        this.overallSum = overallSum;
    }

    // View functions
    changeContact() {
        this.selectBox.single(this.contactsStore, {
            displayField: 'cnr_full_name_co'
        }).then((result) => {
            this.data.contact_id = result.data;
            this.updateContactData();
        });
    }

    addPosition() {
        this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: selectPositionModalTemplate,
            size: 'md',
            controller: 'BillingSelectPositionController',
            controllerAs: 'vm'
        }).result.then((data) => {
            if (data) {
                this.data.positions.push({
                    order: this.data.positions.length + 1,
                    position_id: data.id,
                    label: data.label,
                    originalLabel: _.cloneDeep(data.label),
                    description: data.description,
                    price_per_unit: data.price_per_unit,
                    unit: data.unit,
                    amount: 1
                });
            }
        }, () => {

        });
    }

    removePosition(position) {
        const index = this.data.positions.indexOf(position);

        if (index > -1) {
            this.data.positions.splice(index, 1);
            this.reArrangePositionsOrder();
        }
    }

    moveUp(position) {
        if (position.order > 1) {
            let oldOrder = position.order;
            _.each(this.getPositionsOrdered(), (curPos) => {
                if (curPos.order === oldOrder - 1) {
                    curPos.order++;
                }
            });
            position.order--;
        }
        this.reArrangePositionsOrder();
    }

    moveDown(position) {
        if (position.order < this.getPositionsOrdered().length) {
            let oldOrder = position.order;
            _.each(this.getPositionsOrdered(), (curPos) => {
                if (curPos.order === oldOrder + 1) {
                    curPos.order--;
                }
            });
            position.order++;
        }

        this.reArrangePositionsOrder();
    }

    reArrangePositionsOrder() {
        let currentOrder = 1;
        _.each(this.getPositionsOrdered(), (curPos) => {
            curPos.order = currentOrder++;
        });

        this.scope.$applyAsync();
    }

    getPositionsOrdered() {
        return this.filter('orderBy')(this.data.positions, 'order');
    }

    // Internal
    updateDeposits() {
        const queue = [];

        this.invoiceTemplatesStore.commit('setPermanentFilters', {'enable_for_invoice': true});
        this.invoiceTemplatesStore.commit('setSort', {'title': 'asc'});
        this.invoiceTemplatesStore.commit('setColumns', [{
            key: 'title',
            label: 'Title',
            main: true,
            visible: true
        }, {
            key: 'enable_for_invoice',
            label: 'Enable for Invoice',
            type: 'boolean',
            main: false,
            visible: false
        }, {
            key: 'number_circle.id',
            label: 'Number circle ID',
            type: 'integer',
            main: false,
            visible: true
        }, {
            key: 'tax_rate',
            label: 'Tax rate',
            type: 'float',
            main: false,
            visible: true
        }]);

        queue.push(this.invoiceTemplatesStore.dispatch('getData').then(() => {
            this.deposits.invoice_templates = this.invoiceTemplatesStore.state.data;
        }));

        queue.push(this.paymentsService.getPosTypes().then((types) => {
            this.deposits.payment_types = types;
        }));

        return this.queue.all(queue);
    }

    updateContactData() {
        this.api.get(`contacts/${this.data.contact_id}?include=categories`).then((response) => {
            this.currentContact = response.data.data;
            this.updateAddress();
        }, () => {
            this.data.contact_id = -1;
            this.currentContact = null;
        });
    }

    updateAddress() {
        this.addressEditable = (this.currentSelectedAddressType === 'custom');

        if (!this.currentContact) {
            return;
        }

        if (this.currentSelectedAddressType !== 'custom') {
            let addressPrefix;
            switch (this.currentSelectedAddressType) {
                case 'preferred':
                    addressPrefix = 'preferred_';
                    break;
                case 'private':
                    addressPrefix = '';
                    break;
                case 'business':
                    addressPrefix = 'business_';
                    break;
            }

            let address = '';
            if (this.currentSelectedAddressType === 'business' || (this.currentSelectedAddressType === 'preferred' && this.currentContact.business_preferred)) {
                address += (this.currentContact.company_name).trim();
                if (address !== '') {
                    address += "\n";
                }
                const nameString = (this.currentContact.title + ' ' + this.currentContact.first_name + ' ' + this.currentContact.last_name).trim();
                if (nameString) {
                    address += 'z. H. ' + nameString + "\n";
                } else {
                    address += "\n";
                }
            } else if (this.currentSelectedAddressType === 'shipping' && this.currentContact.shipping_company_name !== '') {
                address += (this.currentContact.shipping_company_name).trim();
                const nameString = (this.currentContact.title + ' ' + this.currentContact.first_name + ' ' + this.currentContact.last_name).trim();
                if (nameString) {
                    address += 'z. H. ' + nameString + "\n";
                } else {
                    address += "\n";
                }
            } else {
                address += (this.currentContact.title + ' ' + this.currentContact.first_name + ' ' + this.currentContact.last_name).trim() + "\n";
            }

            address += this.currentContact[addressPrefix + 'street'] + "\n";
            if (this.currentContact[addressPrefix + 'street_2']) {
                address += this.currentContact[addressPrefix + 'street_2'] + "\n";
            }
            address += this.currentContact[addressPrefix + 'zip'] + ' ' + this.currentContact[addressPrefix + 'city'] + "\n";

            let countryName = '',
                currentCountryCode = this.currentContact[addressPrefix + 'country'];
            if (currentCountryCode) {
                currentCountryCode = currentCountryCode.toUpperCase();
            }
            if (currentCountryCode !== 'DE') {
                _.forEach(this.rootScope.deposit.countries, function (country) {
                    if (country.code === currentCountryCode) {
                        countryName = country.name;
                    }
                });
            }
            address += (countryName + "\n").trim();

            this.data.address = address.trim();
        }
    }

    submit(form) {
        this.submitting = true;

        if (!form.$valid) {
            this.submitting = false;
            this.sweetAlert.error('Validation', 'Please check your data');
            return;
        }

        if (this.data.contact_id < 0) {
            this.submitting = false;
            this.sweetAlert.error('No Contact', 'You need to select a contact, to do a Cash Sale');
            return;
        }

        if (this.data.positions.length < 1) {
            this.submitting = false;
            this.sweetAlert.error('No positions', 'Please make sure to have at minimum 1 position');
            return;
        }

        _.each(this.data.positions, (v, k) => {
            this.data.positions[k].billable_type = 'contact';
            this.data.positions[k].billable_id = this.data.contact_id;
        });

        const dataForApi = {
            invoice_template_id: this.data.invoice_template_id,
            extended: {
                address: this.data.address,
                invoice_date: this.data.invoice_date,
                processing_costs_general: this.data.processing_fee
            },
            positions: _.filter(_.cloneDeep(this.data.positions), (pos) => {
                return pos.amount > 0;
            })
        };

        this.api.post(`billing/invoices/contact/${this.data.contact_id}/invoice/one`, dataForApi).then((invoiceResponse) => {
            this.api.post(`billing/invoices/${invoiceResponse.data.data.id}/payments`, {
                amount: invoiceResponse.data.data.sum_after_tax,
                type: this.data.payment_type,
                payment_time: new Date(),
                status: 'success'
            }).then((paymentResponse) => {
                if (this.usersStore.state.company.csettings.billing.pos_directly_prepare_pickup) {
                    this.api.post(`vouchers/generate/invoice/${invoiceResponse.data.data.id}`).then((voucherInformation) => {
                        if(true) {
                            this.api.post(`billing/invoices/print-pickup`, {
                                invoices: [invoiceResponse.data.data.id]
                            }).then(() => {
                                this.sweetAlert.success('Cash sale succesful', 'Cash sale was successful and all documents will now start to print');
                                this.initSettings();
                            }, () => {
                                this.sweetAlert.error('Error while printing documents', 'Please start pickup manually');
                                this.goToInvoiceDetails(invoiceResponse.data.data.id);
                            });
                        } else {
                            /** @todo Make invoice create email send on pos configurable **/
                            if (this.sendInvoiceToEmailAddress && this.usersStore.state.company.csettings.billing.pos_invoice_email_template_id > 0) {
                                const invoiceData = invoiceResponse.data.data;

                                this.invoiceModel.sendInvoiceWithTemplate(invoiceData, {
                                        id: this.currentContact.id
                                    },
                                    this.usersStore.state.company.csettings.billing.pos_invoice_email_template_id,
                                    true,
                                    this.sendInvoiceToEmailAddress);
                            }

                            this.initSettings();
                            this.submitting = false;

                            this.modal.open({
                                templateUrl: posVouchersModalTemplate,
                                controller: PosVouchersModalController,
                                controllerAs: 'vm',
                                resolve: {
                                    invoiceInformation() {
                                        return invoiceResponse.data.data;
                                    },
                                    vouchersToDisplay() {
                                        return voucherInformation.data.data;
                                    }
                                }
                            });
                        }
                    }, () => {
                        this.sweetAlert.error('Error while creating vouchers', 'Pleae have a look if the vouchers are correct');
                        this.submitting = false;
                    })
                } else {
                    this.sweetAlert.success('Invoice create', 'The invoice has been created successfully');
                    this.submitting = false;
                    this.initSettings();
                }
            }, () => {
                this.sweetAlert.error('Payment not created', `Invoice with number ${invoiceResponse.data.data.number} was created, there just have been problems in creating the payment. Please manually check.`);
                this.submitting = false;
            });

            this.submitting = false;
        }, () => {
            this.sweetAlert.error('Error on saving', 'There was an error while creating the invoice. Please try again.')
            this.submitting = false;
        });
    }

    goToInvoiceDetails(invoiceId) {
        this.state.go('app.billing.invoices.details', {id: invoiceId});
    }
}

PosDefaultController.$inject = [
    '$uibModal',
    'SweetAlert',
    'SelectBox',
    '$http',
    '$q',
    '$filter',
    '$scope',
    '$rootScope',
    '$state',
    'Contacts',
    'Users',
    'InvoiceTemplates',
    'PaymentsService',
    'locale',
    'Invoice'
];



// WEBPACK FOOTER //
// ./src/app/modules/pos/controllers/pos-index-controller.js